import { injectable } from 'inversify';
import { ApiClient } from './ApiClient';

@injectable()
export class ApiClientFactory {
  createApiClient(): ApiClient {
    return new ApiClient();
  }
}
